import AudioAlert from "@/components/census/AudioAlert";
import HeaderSepsis from "@/components/census/HeaderSepsis";
import HeaderTowerReview from "@/components/census/HeaderTowerReview";
import IconList from "@/components/census/IconList";
import SvgIcon from "@/components/census/SvgIcon";
import ChartWithRange from "@/components/shared/chart/ChartWithRange";
import MultiChartWithSharedRange from "@/components/shared/chart/MultiChartWithSharedRange";
import VueChart from "@/components/shared/chart/VueChart";
import ColorLegend from "@/components/shared/ColorLegend";
import ErrorBoundary from "@/components/shared/ErrorBoundary";
import ExternalLink from "@/components/shared/ExternalLink";
import FullScreenDialog from "@/components/shared/FullScreenDialog";
import Legend from "@/components/shared/Legend";
import LinksToAnotherArea from "@/components/shared/LinksToAnotherArea";
import PatientContact from "@/components/shared/PatientContact";
import PopupContainer from "@/components/shared/PopupContainer";
import References from "@/components/shared/References";
import RiskList from "@/components/shared/RiskList";
import SendFeedback from "@/components/shared/SendFeedback";
import TypeAndScreenAndCross from "@/components/shared/TypeAndScreenAndCross";
import WaveformsContainer from "@/components/WaveformsContainer";
import {
  ageHumanReadable,
  dateDiff,
  dateDiffHumanReadable,
  humanReadable,
  timeAgo
} from "@/filters/DateAndTime";
import NumberFilters from "@/filters/Number";
import { shortenRoomNumbers, slice, toUpperCase } from "@/filters/String";
import Vue from "vue";
import DynamicTable from "./shared/table/DynamicTable";

Vue.component("AudioAlert", AudioAlert);
Vue.component("HeaderSepsis", HeaderSepsis);
Vue.component("HeaderTowerReview", HeaderTowerReview);
Vue.component("IconList", IconList);
Vue.component("SvgIcon", SvgIcon);
Vue.component("VueChart", VueChart);
Vue.component("ChartWithRange", ChartWithRange);
Vue.component("ColorLegend", ColorLegend);
Vue.component("ErrorBoundary", ErrorBoundary);
Vue.component("ExternalLink", ExternalLink);
Vue.component("FullScreenDialog", FullScreenDialog);
Vue.component("Legend", Legend);
Vue.component("LinksToAnotherArea", LinksToAnotherArea);
Vue.component("PatientContact", PatientContact);
Vue.component("PopupContainer", PopupContainer);
Vue.component("References", References);
Vue.component("RiskList", RiskList);
Vue.component("SendFeedback", SendFeedback);
Vue.component("DynamicTable", DynamicTable);
Vue.component("TypeAndScreenAndCross", TypeAndScreenAndCross);
Vue.component("WaveformsContainer", WaveformsContainer);
Vue.component("MultiChartWithSharedRange", MultiChartWithSharedRange);

Vue.filter("toFixed", NumberFilters.toFixed);
Vue.filter("ageHumanReadable", ageHumanReadable);
Vue.filter("humanReadable", humanReadable);
Vue.filter("timeAgo", timeAgo);
Vue.filter("dateDiffHumanReadable", dateDiffHumanReadable);
Vue.filter("dateDiff", dateDiff);
Vue.filter("toUpperCase", toUpperCase);
Vue.filter("slice", slice);
Vue.filter("shortenRoomNumbers", shortenRoomNumbers);
